<template>
  <p>
    본 서비스의 아이디는 본인 휴대전화 번호입니다. 본인 휴대전화
    번호가 변경되셨을 경우, 기존 아이디 탈퇴 후 신규 가입
    진행을 해주세요.
  </p>
</template>
<script>
export default {};
</script>
<style lang="">
</style>